/**
 * LabelBadge — Piccola pill colorata per mostrare una label
 */

interface Props {
  name: string;
  color: string;
  onRemove?: () => void;
}

export function LabelBadge({ name, color, onRemove }: Props) {
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium"
      style={{ backgroundColor: color + '22', color, border: `1px solid ${color}55` }}
    >
      {name}
      {onRemove && (
        <button onClick={(e) => { e.stopPropagation(); onRemove(); }} className="hover:opacity-70 transition-opacity leading-none">×</button>
      )}
    </span>
  );
}
